import {useEffect} from 'react';

import {useSelector} from 'react-redux';
import {WithRouterProps} from 'react-router';

import {authTypeSelector, setAuthType} from 'app/auth/slice';
import {getLoginURLWithNext} from 'app/urls';
import {useAsyncActions} from 'app/utils/redux';

interface Props extends WithRouterProps<unknown, {t?: string}> {
  children: JSX.Element;
}

export function CookieAuthChecker({children}: Props): JSX.Element | null {
  const auth = useSelector(authTypeSelector);
  const actions = useAsyncActions({setAuthType});

  useEffect(() => {
    actions.setAuthType({type: 'session-cookie'});
  }, []);

  useEffect(() => {
    if (auth.error != null) {
      const next = getLoginURLWithNext();
      window.location.replace(next);
    }
  }, [auth.error]);

  return auth.type == null ? null : children;
}
